import { Component, Host, h, Prop } from '@stencil/core';
import type { CssClassMap } from '../../../helpers/utils/interfaces';

@Component({
  tag: 'cms-accordion-group',
  styleUrl: 'cms-accordion-group.scss',
  shadow: true,
})
export class CmsAccordionGroup {
  /**
   * Set Accordion Layout full 100% or two-thirds 66%
   */
  @Prop() layout: 'full' | 'two-thirds' = 'two-thirds';
  /**
   * set the accessible name
   */
  @Prop() accessibleName: string;

  private getCssClassMap(): CssClassMap {
    return {
      [this.layout]: true,
      'accordion-section-inner': true,
    };
  }
  private classMap = this.getCssClassMap();

  render() {
    return (
      <Host>
        <section class='accordion-section' aria-label={this.accessibleName}>
          <div class={this.classMap}>
            <slot />
          </div>
        </section>
      </Host>
    );
  }
}
